import { useMemo } from 'react'
import { Loader2 } from 'lucide-react'
import { SimpleMarkdown } from '@/frontend/components/SimpleMarkdown'
import { artifactCopy as copy } from '@/frontend/features/AgentChats/artifacts/copy'
import { documentFormat, HTML_PREVIEW_SANDBOX, sandboxedHtml } from '@/frontend/features/AgentChats/artifacts/documentFormat'
import { useDocumentText } from '@/frontend/features/AgentChats/artifacts/useDocumentText'
import type { AgentChatAttachment } from '@/frontend/pages/Dashboard/AgentChats/types'

export function DocumentPreview({ attachment, active = true, source = false }: {
  attachment: AgentChatAttachment; active?: boolean; source?: boolean
}) {
  const { text, failed, tooLarge, retry } = useDocumentText(attachment, active)
  const format = documentFormat(attachment.filename, attachment.content_type)
  const html = useMemo(() => format === 'html' && text !== undefined ? sandboxedHtml(text) : '', [format, text])

  if (tooLarge || failed) return <div role="status" className="flex h-full flex-col items-center justify-center gap-3 p-6 text-center text-sm text-muted-foreground">
    <p>{tooLarge ? copy.tooLarge : copy.error}</p>
    {!tooLarge && <button type="button" onClick={retry} className="rounded-md border border-border px-3 py-2 text-foreground hover:bg-accent">{copy.retry}</button>}
  </div>
  if (text === undefined) return <div role="status" className="flex h-full items-center justify-center gap-2 text-sm text-muted-foreground">
    <Loader2 aria-hidden="true" className="size-4 animate-spin" />{copy.loading}
  </div>
  if (source) return <pre className="m-0 h-full overflow-auto whitespace-pre-wrap break-words p-5 font-mono text-xs leading-6 text-foreground">{text}</pre>
  if (format === 'html') return <iframe title={attachment.filename} srcDoc={html} sandbox={HTML_PREVIEW_SANDBOX} referrerPolicy="no-referrer" className="h-full w-full border-0 bg-white" />
  return <article className="mx-auto max-w-4xl px-5 py-8 sm:px-10">
    <SimpleMarkdown content={text} interactiveTables className="break-words" />
  </article>
}
